
import { useNavigate } from 'react-router-dom'

export const useRedirect = () => {

    const navigate = useNavigate()

    //👉El objeto "state" sirve para enviar props cuando se navega entre rutas

    const redirectTo = (path, status,state = {}) => {
        if (!path) return
        if (status && status === 200) {
            navigate(path , {state})
        }

    }

    return { redirectTo }

}
